import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import ErrorFallback from 'core/components/common/ErrorFallback';
import { LoadingSkeleton } from 'core/components/common/LoadingSkeleton';
import { IncidentDetailPageLayout } from 'core/components/layout/pages/IncidentDetailPageLayout';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { IncidentDetail } from 'sections/ube/features/IncidentDetail';

export const IncidentDetailPage = () => {
  const { reset } = useQueryErrorResetBoundary();
  return (
    <IncidentDetailPageLayout>
      <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => reset()}>
        <Suspense fallback={<LoadingSkeleton />}>
          <IncidentDetail />
        </Suspense>
      </ErrorBoundary>
    </IncidentDetailPageLayout>
  );
};
